import { all, call, fork, put, select, takeEvery } from "redux-saga/effects"
import * as fetchApi from "services/api/fetchApi"
import { webStorage } from "services/utils"
import Cookies from "universal-cookie"

import { globalUiAction } from "./action"

const cookies = new Cookies()

function* getFetchGlobalData({ payload }) {
  try {
    const unRequested = yield all(
      payload.requestData.filter((request) => {
        const hasData = cookies.get(request.name) && webStorage.getLs(request.name) ? true : false
        if (!hasData) {
          webStorage.removeLs(request.name)
        }
        return !hasData
      }),
    )
    // save data to localStorage
    if (unRequested.length) {
      yield all(unRequested.map((request) => call(saveToLocalStorage, request)))
    }
    // save to store
    const initData = yield payload.requestData.reduce(
      (obj, request) => Object.assign(obj, { [`${request.name}`]: webStorage.getLs(request.name) }),
      { [`${payload.name}`]: true },
    )

    yield put(globalUiAction.setGlobalUI(initData))
  } catch (error) {
    if (error?.response?.status === 401) {
      return window.location.reload()
    }
    yield put(
      globalUiAction.openErrorModal({
        title: "Initial failed",
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    if (payload.loading) {
      yield put(globalUiAction.setGlobalUI({ isLoading: false }))
    }
  }
}

function* saveToLocalStorage(request) {
  const response =
    request.method === "get"
      ? yield call(fetchApi.getDataByFetch, request.url)
      : yield call(fetchApi.postDataByFetch, request.url, request.postData)

  if (response.data.Result === 1) {
    // yield cookies.set(request.name, '1800', { maxAge: 1800 });
    yield webStorage.setLs(request.name, response.data.Data)
  } else if (response.data.result === 1) {
    // yield cookies.set(request.name, '1800', { maxAge: 1800 });
    yield webStorage.setLs(request.name, response.data.data)
  } else {
    yield put(
      globalUiAction.openErrorModal({
        title: "Fetch failed",
        content: `${request.name} ${response.data.MessageCode}, ${response.data.Message}`,
      }),
    )
  }
}

function* openModal({ payload, callback }) {
  const modal = yield select((state) => state.globalUi.modal)
  modal?.current?.open?.(payload).then(callback)
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchFetchGlobalData() {
  yield takeEvery(globalUiAction.GLOBAL_DATA_REQUEST, getFetchGlobalData)
}

export function* watchOpenModal() {
  yield takeEvery(globalUiAction.OPEN_MODAL, openModal)
}

//=====================================
//  ROOT
//-------------------------------------

export const globalUiSaga = [fork(watchFetchGlobalData), fork(watchOpenModal)]
